module.exports = __webpack_public_path__ + "static/media/AS.188cb88e.webp";